<template>
  <div class="orderTypes">
    <router-link
      v-for="item in orderTypeList"
      :key="item.path"
      :class="{
        'active': $route.path === item.path
      }"
      :to="item.path">
      {{ item.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "orderTypes",
  props: {
    orderTypeList: {
      type: Array,
      require: true,
    }
  }
};
</script>

<style scoped lang='less'>
.orderTypes{
  height: .933333rem;
  line-height: .97777rem;
  background: #FFFFFF;
  text-align: center;
  color: #A1A6BA;
  font-size: .426667rem;
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 0.13rem;
  .active{
    color: #9D6C29;
  }
}
</style>
